<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <template>
            <div class="container-fluid xyz">
                <!--page content-->
                <div class="admin-page-content">
                    <div class="page-title-container">
                        <div class="page-name">{{pageTitle}}</div>
                        <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                    </div>
                    <!--Forms-->
                    <div class="forms-container default-bx-shadow responsive-forms-container">
                        <div class="row no-margin">
                            <!-- Name -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="location_name_error = ''" maxlength="190" class="form-control" v-model="location_name" id="location_name" placeholder="Enter Location Name" name="location_name">
                                    <div class="help is-danger">{{location_name_error}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <!-- Select Form -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Select Form :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="form" name="form"
                                        @change="changedValue"
                                        label="text" @input="form_Error = ''"
                                        :options="formArr" :clearable=false placeholder="Select Form">
                                    </v-select>
                                    <div class="help is-danger">{{form_Error}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <!-- <template> -->
                                <!-- Excede Location Id -->
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label">Excede Location Id :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="number" @input="excede_location_id_error = ''" maxlength="500" class="form-control" v-model="excede_location_id" id="excede_location_id" placeholder="Enter Excede Location Id" name="excede_location_id">
                                        <div class="help is-danger">{{excede_location_id_error}}</div>
                                        <div v-show="form.value == 'gl_export'" class="requiredstar">*</div>
                                    </div>
                                </div>
                                <!-- Display Order -->
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label">Display Order :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="number" @input="display_order_error = ''" maxlength="500" class="form-control" v-model="display_order" id="display_order" placeholder="Enter Display Order" name="display_order">
                                        <div class="help is-danger">{{display_order_error}}</div>
                                    </div>
                                </div>
                            <!-- </template> -->

                            <div class="clearfix"></div>
                            <div class="mr-17 pb-12 float-l">
                                <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                                <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addFormMapperData('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button>
                                <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addFormMapperData('save')"><span id="createAttachment">Save</span></button>
                            </div>

                        </div>
                    </div>
                    <!-- Forms -->
                </div>
                <!--page content-->
            </div>
        </template>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPVELOCITY} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import EventBus from "../event-bus";
    import VueTagsInput from '@johmun/vue-tags-input';
    import {getHeader} from "../../config";

    var app;
    Vue.component('v-select', vSelect);
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdateLocationManager',
        mixins: [commonMixins],
        components: {
            VueTagsInput,
        },
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Add Location Manager',
                edit_id: 0,
                validation: [{
                    classes: 'valid-email',
                    rule: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                }],
                excede_location_id:"",
                excede_location_id_error:"",
                display_order_error: "",
                display_order: "",
                location_name: "",
                location_name_error: "",
                loginUserRoleId: 1,
                old_location_id: 0,
                old_dept_id: 0,
                form: {text: 'GL Export', value: 'gl_export'},
                formArr: [{
                        text: 'GL Export',
                        value: 'gl_export'
                    },
                    {
                        text: 'Top Facility Export',
                        value: 'top_facility_export'
                    }],
                form_Error: "",
            }
        },
        watch: {
        },
        beforeMount: function () {
            app = this;
        },
        created: function () {
        },
        mounted: function () {
          //  app.loadFormMasterData();
            app.setActiveMenu("location-manager");
            EventBus.$emit("menu-selection-changed", "location-manager");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
              //  app.loginUserRoleId = userJson['role'].system_id;
            }
            this.$nextTick(function () {
                if (typeof(app.$route.params.id)  != 'undefined' && app.$route.params.id != 0 && app.$route.params.id != '') {
                    app.edit_id = app.$route.params.id;
                    app.pageTitle = 'Edit Location Manager';
                    app.getLocationDataById();
                    $("#addAndContinueLocationBtn").hide();
                    $("#createAttachment").html("Update");
                }
            });
            // app.loadBodyShopLocation();
        },
        methods: {
            changedValue: function (value) {
                if(app.edit_id == 0) {
                    app.excede_location_id = "";
                    app.excede_location_id_error = "";
                }
            },

            buttonBack() {
                app.$router.push('/location-manager');
            },
            
            getLocationDataById: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: app.edit_id,
                    }
                };
                app.showLoader();
                HTTP.get("/location/manager/getbyid", config)
                        .then(function (response) {
                            setTimeout(function() {
                                app.location_name=response.data.content.name;
                                app.excede_location_id=response.data.content.excede_location_id;
                                app.display_order=response.data.content.display_order;
                                if(response.data.content.is_form == 'gl_export') {
                                    var form = app.formatString(response.data.content.is_form).split(' ');
                                    form = form[0].toUpperCase() +" "+ form[1];
                                    app.form = {text:form, value:response.data.content.is_form};
                                } else {
                                    app.form = {text:app.formatString(response.data.content.is_form), value:response.data.content.is_form};
                                }
                                console.log(app.form);
                                app.hideLoader();
                            }, 50);
                        })
                        .catch(function (err) {
                            console.log(err);
                            app.hideLoader();
                            app.catchHandler(err, function () {});
                            app.$router.push('/location-manager');
                        });
            },
            
            checkForm: function () {
                var checked = true;
                app.excede_location_id_error="";
                app.display_order_error= "";
                app.location_name_error= "";
                app.form_Error = "";
                
                if (app.location_name.length == 0) {
                    app.location_name_error = "Name is required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (app.form.length == 0) {
                    app.form_Error = "Select form is required";
                    if (checked) {
                        checked = false;
                    }
                }
                if(app.form.value == "gl_export") {
                    if (app.excede_location_id == 0 || app.excede_location_id>5000) {
                        app.excede_location_id_error = "Excede location id is required";
                        if (checked) {
                            checked = false;
                        }
                    }
                } else {
                    if (app.excede_location_id && (app.excede_location_id == 0 || app.excede_location_id>5000)) {
                        app.excede_location_id_error = "Excede location id must be between 0 to 5000";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if(app.display_order > 32767) {
                    app.display_order_error = "Display order must be less than 32767";
                    if (checked) {
                        checked = false;
                    }
                }
                
                return checked;
            },
            addFormMapperData(flag) {
                setTimeout(() => {
                    if (app.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        };
                        let deptName="", deptId=0;
                        var fields = {
                            id: app.edit_id,
                            name: app.location_name,
                            excede_location_id: app.excede_location_id,
                            display_order:app.display_order,
                            form_type: app.form.value
                        };
                        app.showLoader();
                        HTTP.post("/location/manager/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    app.showSAlert(response.data.message, 'success');
                                    if (flag == 'save') {
                                        app.buttonBack();
                                    } else {                                        
                                        app.clearSaveAndContinue();
                                    }
                                }
                                app.hideLoader();
                            })
                            .catch(function (err) {
                                app.hideLoader();
                                app.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            clearSaveAndContinue: function() {
                app.edit_id = 0;
                app.location_name="";
                app.excede_location_id="";
                app.display_order="";
                app.form = {text: 'GL Export', value: 'gl_export'};
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            numberFormateValidation : function (inputtxt) {
                var valid = !/^\s*$/.test(inputtxt) && !isNaN(inputtxt);
                return valid;
            },
        }
    };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/LocationManager/AddUpdateLocationManager.vue